/* eslint-disable indent */

/* Example Usage:

const indicationSelectionErrorHtml = new IndicationSelectionErrorHtml('An error occured');

console.log('indicationSelectionErrorHtml', indicationSelectionErrorHtml.toString());

*/

export default class IndicationSelectionErrorHtml {
    constructor(errorText) {
        this._errorText = errorText;
    }

    toString() {
        return `
            <div class="rfct-indication-selection rfct-indication-selection--error">
                <div class="rfct-indication-selection__error-message">
                    <!--<div class="rfct-indication-selection__error-icon">
                        <svg><use xlink:href="styles/spritemap.svg#error-outline"></use></svg>
                    </div>-->
                    <div class="rfct-indication-selection__error-text">${this._errorText}</div>
                </div>
            </div>
        `;
    }
}
